import { render, staticRenderFns } from "./job-link-job-manager.component.vue?vue&type=template&id=27e4cd95"
import script from "./job-link-job-manager.component.ts?vue&type=script&lang=ts&external"
export * from "./job-link-job-manager.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e4cd95')) {
      api.createRecord('27e4cd95', component.options)
    } else {
      api.reload('27e4cd95', component.options)
    }
    module.hot.accept("./job-link-job-manager.component.vue?vue&type=template&id=27e4cd95", function () {
      api.rerender('27e4cd95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/job-link-job-manager/job-link-job-manager.component.vue"
export default component.exports